<template>
  <v-autocomplete
    v-bind:value="modelValue"
    :items="items"
    item-text="name"
    item-value="id"
    v-bind="$attrs"
    :loading="!hideLoading ? loading : false"
    v-on="inputListeners"
  >
    <template v-slot:progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        color="primary"
        indeterminate
      ></v-progress-linear>
    </template>

    <template v-slot:prepend-item v-if="multiplaSelecao && items.length">
      <v-list-item
        v-if="modelValue.length === items.length"
        class="pl-14px py-2"
        @click="updateModelValue([])"
      >
        <v-icon color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="pl-14px py-2"
        @click="selectAll()"
      >
        <v-icon v-if="modelValue.length > 0" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template v-slot:selection="{item}" v-if="multiplaSelecao">
      <template v-if="modelValue.indexOf(item.id) < qtdeVisivelSelecionados">
        <span class="text-truncate" style="max-width: 150px">{{item.name}}</span><template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="modelValue.indexOf(item.id) === qtdeVisivelSelecionados">
        <span class="ml-1 text-gray-700 font-13">(+ {{modelValue.length - qtdeVisivelSelecionados}})</span>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import UsuarioAPI from "../../../api/usuario.js";

export default {
  name: "SysUsuariosAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true
    },
    qtdeVisivelSelecionados: {
      type: [Number],
      default: 4
    },
    hideLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    items: [],
    loading: false
  }),
  computed: {
    inputListeners: function () {
      const vm = this;

      return Object.assign({},
        vm.$listeners, {
          input: function (ev) {
            vm.updateModelValue(ev);
          }
        }
      )
    },
    multiplaSelecao () {
      return ![null, undefined].includes(this.$attrs.multiple);
    }
  },
  created() {
    this.getItems();
  },
  methods: {
    updateModelValue (newValue) {
      this.$emit("update:modelValue", newValue);
    },
    selectAll() {
      this.updateModelValue(this.Helpers.arrayColumn(this.items, 'id'))
    },
    getItems () {
      this.loading = true;
      const headers = this.Helpers.iniciarRequisicao();

      UsuarioAPI.getUsuarios(headers, {filtrar_admin: 'S'})
        .then((response) => {
          const {token, usuarios} = response.data;
          localStorage.token = token;
          this.items = usuarios.map(item => {
            item.name = `${item.id} - ${item.name}`
            return item;
          });
          this.selectAll();
          this.loading = false;
        })
        .catch(() => this.Helpers.logout())
    },
    apendarVirgula (item) {
      const indexOf = this.modelValue.indexOf(item.id)
      return indexOf !== this.modelValue.length - 1 && indexOf < (this.qtdeVisivelSelecionados - 1)
    }
  }
}
</script>

<style scoped>

</style>
